module.exports = __webpack_public_path__ + "static/media/b0.d199be0b.png";